import ValueObject from "../../../../../frontend/ValueObject";
import {Money} from "./Money";
import {PricingPriceDTO} from "./dto/PricingDTO";
import {PricingMoney} from "./PricingMoney";

export interface IPrice {
    amount: number,
    currency: string,
}

export class PricingPrice extends ValueObject<IPrice> {
    constructor(pricingPrice: PricingPriceDTO) {
        super({
            amount: pricingPrice.amount / 100,
            currency: pricingPrice.currency ? pricingPrice.currency : 'EUR'
        });
    }

    get currency(): string {
        return this._props.currency;
    }

    get amount(): number {
        return this._props.amount;
    }

    get locale(): string {
        return document.body.getAttribute('data-locale') ?? navigator.language;
    }


    get value(): string {
        return this.render();
    }

    toString(): string {
        return this.render( null );
    }

    toStringLimitedSpace(): string {
        return this.render( null, false, this.currency === 'EUR' );
    }

    render( centsHtmlTag: string = 'sub', spaceBetweenSymbolAndAmount: boolean = false, withSymbol: boolean = true ): string {
        return (new PricingMoney(this, this.locale)).format( centsHtmlTag, spaceBetweenSymbolAndAmount, withSymbol );
    }
}
